export default "__VITE_ASSET__C2_x3JAW__"